import { z } from 'zod'

export const GetAddressSchema = z.object({
  address: z.string().nullish(),
  city: z.string().nullish(),
  country: z.string().nullish(),
  country_code: z.string().nullish(),
  id: z.number().nullish(),
  lat: z.string().nullish(),
  lng: z.string().nullish(),
  place_id: z.string().nullish(),
  place_name: z.string().nullish(),
  postcode: z.string().nullish(),
  region: z.string().nullish(),
})

export const GetAddressComponentSchema = z.object({
  long_name: z.string(),
  short_name: z.string(),
  types: z.array(z.string()),
})

export const GetCountrySchema = z.object({
  code: z
    .string()
    .nullish()
    .transform(value => value || undefined),
})

export const GetAddressBookSchema = z.object({
  company_id: z.number(),
  id: z.number(),
  name: z.string(),
  slug: z.string().nullish(),
  user_id: z.number(),
})
